<template>
    <div class="GardenConf">
        <header class="GardenConf-header u-frameMd">
            <h1><span>Zelená</span> kalkulačka</h1>
        </header>
        <router-view
            v-if="configuration.paths[$route.name]"
            :configuration="configuration"
            :steps="configuration.paths[$route.name].steps"
            :id="configuration.configuratorId"
            :result="resultConfig"
            :settings="stepSettings"
            :packages="configuration.discountPackages"
            :total="totalConfig"
            :gift="gift">
        </router-view>
        <ConfiguratorPaths
            v-else
            :paths="configuration.paths"
            :title="configuration.title"
            :text="configuration.text"
            map="/images/mapa-udrzby.png"
            image="/images/maintenance-main.jpg">
        </ConfiguratorPaths>
    </div>
    <help-box :person="configuration.infobox"></help-box>
</template>

<script>
import ConfiguratorPaths from "../components/ConfiguratorPaths.vue";
import {getMaintenanceConfigurator, getConfigurationForEdit} from "../api/api";
import useConfiguration from '../composables/useConfiguration.js';
import {useRouter, useRoute} from 'vue-router';
import HelpBox from "../components/HelpBox";

export default {
    components: {HelpBox, ConfiguratorPaths},
    async setup() {
        const router = useRouter();
        const route = useRoute();
        let initialConfiguration = null;

        try {
            if (route.query.hash && route.query.id) {
                initialConfiguration = await getConfigurationForEdit(route.query.id, route.query.hash);
            } else {
                initialConfiguration = await getMaintenanceConfigurator();
            }
        } catch (e) {
            router.push('/404');
        }

        const {
            configuration,
            stepSettings,
            resultConfig,
            totalConfig,
            gift
        } = useConfiguration(initialConfiguration, router, route);

        return {
            configuration,
            stepSettings,
            resultConfig,
            totalConfig,
            gift
        }
    },
}
</script>
